import { AccountSchema } from '../requests/api/apiTypes';

export const SET_USER_ACCOUNT = '@user-account/set-user-account';
export const RESET_USER_ACCOUNT = '@user-account/reset-user-account';
export const SET_LOCAL_ACCOUNTS = '@user-account/set-local-accounts';
export const RESET_LOCAL_ACCOUNTS = '@user-account/reset-local-accounts';

export const setUserAccount = (accountData: AccountSchema) => {
  localStorage.setItem('selectedAccount', JSON.stringify(accountData));
  return {
    type: SET_USER_ACCOUNT,
    payload: {
      ...accountData,
    },
  };
};

export const resetUserAccount = () => ({
  type: RESET_USER_ACCOUNT,
});

export const setLocalAccounts = (accounts: AccountSchema[]) => ({
  type: SET_LOCAL_ACCOUNTS,
  payload: accounts,
});

export const resetLocalAccounts = () => ({
  type: RESET_LOCAL_ACCOUNTS,
});
